module.exports = __webpack_public_path__ + "static/media/exchange.31190d91.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Home/img/exchange.svg
// module id = 238
// module chunks = 8